const useErrorsCount = (data) => {
  const isNotToday = (date) => (
    new Date().toDateString() !== new Date(date).toDateString()
  )

  const imports = data.filter(i => (
    !i.isCallback &&
    !i.isNewFile && (
      i.isCompliant === false ||
      i.lastAudit?.successful === false ||
      isNotToday(i.dataGatheredAt) ||
      isNotToday(i.complianceCheckedAt)
    )
  )).length

  const callbacks = data.filter(i => (
    i.isCallback && (
      i.lastAudit?.successful === false || 
      isNotToday(i.dataGatheredAt)
    )
  )).length

  const newFiles = data.filter(i => i.isNewFile).length

  return {
    imports,
    callbacks,
    newFiles
  }
}

export default useErrorsCount
